<div class="row mb-4">
    <div class="col-sm-12 mx-auto">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <h4 class="card-title col-12 mb-4">Edit DCCS</h4>
                    <div class="text-center" *ngIf="!formGroup?.controls?.id">
                        <div class="spinner-grow" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                    <form *ngIf="formGroup?.controls?.id" #theForm="ngForm" (ngSubmit)="submitForm(formGroup)" novalidate class="col-12">
                        <div [formGroup]="formGroup">
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label class="required">Type</label>
                                </div>
                                <div class="col-md-8">
                                    <div class="form-check">
                                        <input class="form-check-input" formControlName="type" type="radio" value="pre" id="type-pre" required>
                                        <label class="form-check-label" for="type-pre">
                                            Pre-Switch
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" formControlName="type" type="radio" value="post" id="type-post" required>
                                        <label class="form-check-label" for="type-post">
                                            Post-Switch
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" formControlName="type" type="radio" value="border" id="type-border" required>
                                        <label class="form-check-label" for="type-border">
                                            Border Phase
                                        </label>
                                    </div>
                                    <div class="text-danger" *ngIf="formGroup.get('type')?.invalid && (theForm.submitted || formGroup.get('type')?.touched)">
                                        <small *ngIf="formGroup.get('type')?.errors?.required">Select type</small>
                                        <small *ngIf="formGroup.get('type')?.errors?.serverError">{{formGroup.get('type')?.errors?.serverError}}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label class="required">Point</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="number" formControlName="point" class="form-control" [class.is-invalid]="formGroup.get('point')?.invalid && (theForm.submitted || formGroup.get('point')?.touched)" placeholder="Type point" required>
                                    <div class="text-danger" *ngIf="formGroup.get('point')?.invalid && (theForm.submitted || formGroup.get('point')?.touched)">
                                        <small *ngIf="formGroup.get('point')?.errors?.required">Type point</small>
                                        <small *ngIf="formGroup.get('point')?.errors?.serverError">{{formGroup.get('point')?.errors?.serverError}}</small>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="formGroup.get('type')?.value=='border'" class="row mb-4">
                                <div class="col-md-4">
                                    <label>Bordered</label>
                                </div>
                                <div class="col-md-8">
                                    <div class="form-check">
                                        <input class="form-check-input" formControlName="bordered" type="checkbox" id="bordered">
                                        <label class="form-check-label" for="bordered">
                                            Yes
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label class="required">Question image</label>
                                </div>
                                <div class="col-md-8">
                                    <div class="input-group">
                                        <input class="form-control" placeholder="Choose file" [value]="question?.file?.name" readonly (click)="inputQuestion.click()" [attr.disabled]="loading.status ? 'disabled' : null">
                                        <button type="button" class="btn btn-outline-primary" (click)="inputQuestion.click()" [attr.disabled]="loading.status ? 'disabled' : null">
                                            <i class="material-icons">search</i>
                                        </button>
                                        <input class="d-none" #inputQuestion accept=".jpg,.jpeg,.png" (change)="fileHandler.handle($event, question, 'image/png,image/jpg,image/jpeg')" type="file">
                                    </div>
                                    <small>FileType: png,jpg; resolution: 100x100 pixel</small>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label>Voice</label>
                                </div>
                                <div class="col-md-8">
                                    <div class="input-group">
                                        <input class="form-control" placeholder="Choose file" [value]="voice?.view ?? ''" readonly (click)="inputVoice.click()" [attr.disabled]="loading.status ? 'disabled' : null">
                                        <button type="button" class="btn btn-outline-primary" (click)="inputVoice.click()" [attr.disabled]="loading.status ? 'disabled' : null">
                                            <i class="material-icons">search</i>
                                        </button>
                                        <input class="d-none" #inputVoice accept=".mp3" (change)="fileHandler.handle($event, voice, 'audio/mpeg,audio/x-mpeg3,audio/mpeg3', (0.5))" type="file">
                                    </div>
                                    <small>FileType: mp3, size: 500kb</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 mb-3">
                                    <div class="fs-5">Answer choice</div>
                                </div>
                                <div class="col-12">
                                    <table class="table table-borderless">
                                        <thead>
                                            <tr>
                                                <th class="text-center">
                                                    #
                                                </th>
                                                <th>
                                                    Image<br>
                                                    <small class="fw-normal">Filetype: png,jpg; resolution: 100x100 pixel</small>
                                                </th>
                                                <th>
                                                    Is correct answer?<br>
                                                    <small class="fw-normal">Mark if its true</small>
                                                </th>
                                                <th>
                                                    Remove
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let d of details;index as i">
                                                <td class="text-center">
                                                    {{i+1}}
                                                </td>
                                                <td>
                                                    <div class="d-flex align-items-center">
                                                        <div *ngIf="details[i].image?.view" class="border me-2 p-1 rounded position-relative">
                                                            <img src="{{details[i].image.view}}" style="height:32px;width:auto" />
                                                        </div>
                                                        <div>
                                                            <button type="button" class="btn btn-sm btn-outline-primary" (click)="browseImage(i);" [attr.disabled]="loading.status ? 'disabled' : null">
                                                                <i class="material-icons fs-6">search</i>
                                                            </button>
                                                            <input class="d-none" id="input-image-{{i}}" accept=".png,.jpg" (change)="fileHandler.handle($event, details[i].image, 'image/png,image/jpg,image/jpeg')" type="file">
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-check">
                                                        <input class="form-check-input" [attr.disabled]="loading.status || !details[i].image?.view ? 'disabled': null" type="checkbox" (click)="isTrue($event, i)" [checked]="d.is_true">
                                                    </div>
                                                </td>
                                                <td>
                                                    <button [attr.disabled]="loading.status ? 'disabled' : null" class="btn btn-sm btn-danger" (click)="removeDetails(i)">
                                                        <i class="material-icons fs-6">delete</i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-12" *ngIf="details.length<2">
                                    <button (click)="addDetails()" [attr.disabled]="loading.status ? 'disabled' : null" type="button" class="btn btn-secondary">
                                        Add Choice
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center border-top pt-4 mt-4">
                            <div>
                                &nbsp;
                            </div>
                            <div class="text-end">
                                <button type="button" class="btn btn-secondary" (click)="back();" [attr.disabled]="loading.status ? 'disabled' : null">
                                    <i class="material-icons">close</i> &nbsp;
                                    Cancel
                                </button>
                                &nbsp;
                                <button type="submit" class="btn btn-primary" [attr.disabled]="loading.status ? 'disabled' : null">
                                    <i class="material-icons">save</i> &nbsp;
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
